import { PureComponent } from "react";
import styled from "styled-components";
import TextField from "basicComponents/TextField/TextField";
import SimpleSearch from "basicComponents/SimpleSearch/SimpleSearch";
import * as PropTypes from "prop-types";
import messages from "./messages";
import { FormattedMessage } from "react-intl";
import GlobalMessages from "../../../messages/messages";

export default class PatientInfo extends PureComponent {
  static propTypes = {
    insurers: PropTypes.array.isRequired,
    insuranceNumber: PropTypes.string.isRequired,
    internalRef: PropTypes.any.isRequired,
    onInsurerChanged: PropTypes.func.isRequired,
    onDentistChanged: PropTypes.func.isRequired,
    insurerIndex: PropTypes.number.isRequired,
    dentistIndex: PropTypes.number.isRequired,
    onInsuranceNumberChanged: PropTypes.func.isRequired,
    onInternalRefChanged: PropTypes.func.isRequired,
    patient: PropTypes.any,
    dentists: PropTypes.array.isRequired,
    practice: PropTypes.any.isRequired,
    initialInputText: PropTypes.string,
    showArrow: PropTypes.bool,
    onNameChanged: PropTypes.func.isRequired,
    getDentist: PropTypes.func,
  };

  state = {
    searchText: "",
    searchTextDentist: "",
  };

  handleSearchTextChanged = searchText => {
    this.setState({
      searchText,
    });
  };

  handleChange = searchTextDentist => {
    this.setState({
      searchTextDentist,
    });
  };

  handleUglyButtonClicked = () => {
    this.save(() => {});
  };

  save = callback => {
    const dentist = {
      name: this.props.value || this.state.searchTextDentist,
      practiceId: this.props.practice.id,
    };
    this.props.createDentist(dentist, callback, false);
  };

  render() {
    const {
      insurers,
      insuranceNumber,
      onInsurerChanged,
      onDentistChanged,
      insurerIndex,
      dentistIndex,
      onInsuranceNumberChanged,
      onInternalRefChanged,
      patient,
      internalRef,
      dentists,
      onNameChanged,
      onButtonClickValidation = false,
    } = this.props;

    const lowerSearchText = this.state.searchText.toLowerCase();
    let filteredSelected = insurerIndex;
    const filtered = insurers.filter(insurer =>
      insurer.toLowerCase().includes(lowerSearchText),
    );
    if (insurerIndex >= 0) {
      const selected = insurers[insurerIndex];
      filteredSelected = filtered.findIndex(insurer => insurer === selected);
    }
    const lowerSearchTextDentist = this.state.searchTextDentist.toLowerCase();
    let filteredSelectedDentist = dentistIndex;
    const filteredDentist = dentists.filter(dentist =>
      dentist.toLowerCase().includes(lowerSearchTextDentist),
    );
    if (dentistIndex >= 0) {
      const selectedDentist = dentists[dentistIndex];
      filteredSelectedDentist = filteredDentist.findIndex(
        dentist => dentist === selectedDentist,
      );
    }

    function handleInsurerSelected(name) {
      const index = insurers.findIndex(insurer => insurer === name);
      if (index !== -1) {
        onInsurerChanged(name, index);
      }
    }

    function handleDentistSelected(name) {
      const index = dentists.findIndex(dentist => dentist === name);
      if (index !== -1) {
        onDentistChanged(name, index);
      }
    }

    return (
      <Wrapper id="newTreatmentPatientInfo">
        <FieldWrapper>
          <TextField
            noPadding
            id="name"
            value={patient.name}
            onChange={onNameChanged}
            placeholder={messages.patient}
            required
            error={onButtonClickValidation && patient.name.length < 2}
          />
          {onButtonClickValidation &&
            (patient.name.length < 2 && (
              <ErrorText data-cy="errorName">
                <FormattedMessage {...messages.errorMsgPatientName} />
              </ErrorText>
            ))}
        </FieldWrapper>
        <FieldWrapper>
          <TextField
            noPadding
            id="internalRef"
            value={internalRef}
            onChange={onInternalRefChanged}
            placeholder={messages.internalRef}
          />
        </FieldWrapper>
        <FieldWrapper>
          <SimpleSearch
            id="insurerDropdown"
            value={this.state.searchText}
            onValueChanged={this.handleSearchTextChanged}
            onClick={handleInsurerSelected}
            items={filtered}
            selectedIndex={filteredSelected}
            placeholder={GlobalMessages.insurer}
            closable
            noPadding
            error={onButtonClickValidation && insurerIndex === -1}
            isRequired
          />
          {onButtonClickValidation &&
            (insurerIndex === -1 && (
              <ErrorText data-cy="errorInsurer">
                <FormattedMessage {...messages.selectInsurer} />
              </ErrorText>
            ))}
        </FieldWrapper>
        <FieldWrapper>
          <TextField
            noPadding
            id="insuranceNumber"
            value={insuranceNumber}
            onChange={onInsuranceNumberChanged}
            placeholder={messages.insuranceNumber}
          />
        </FieldWrapper>
        <FieldWrapper>
          <SimpleSearch
            id="dentistDropdown"
            value={this.state.searchTextDentist}
            onValueChanged={this.handleChange}
            onClick={handleDentistSelected}
            items={filteredDentist}
            selectedIndex={filteredSelectedDentist}
            placeholder={GlobalMessages.dentist}
            closable
            noPadding
            noResultButtonId="addNewDentistButton"
            enableUglyLongButtonOnNoResult
            handleUglyButtonClicked={this.handleUglyButtonClicked}
            iconButtonText={
              <NewDentistButton>
                <FormattedMessage {...GlobalMessages.addNewDentist} />
              </NewDentistButton>
            }
            customHeight="25px"
            fullWidth
            customPadding={8}
            customIconScale={0.6}
            error={onButtonClickValidation && dentistIndex === -1}
            isRequired
          />
          {onButtonClickValidation &&
            (dentistIndex === -1 && (
              <ErrorText data-cy="errorDentist">
                <FormattedMessage {...messages.selectDentist} />
              </ErrorText>
            ))}
        </FieldWrapper>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 10px;
  min-width: 450px;
`;

const NewDentistButton = styled.div`
  text-align: left;
  font-size: 15px;
  font-weight: bold;
`;
const ErrorText = styled.div`
  text-align: center;
  font-size: 12px;
  color: #ff543c;
`;

const FieldWrapper = styled.div`
  margin-left: ${({ theme }) => theme.padding}rem;
  margin-right: ${({ theme }) => theme.padding}rem;
  margin-top: ${({ theme }) => theme.padding}rem;
  padding-bottom: ${({ theme }) => theme.padding}rem;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  &:last-child {
    border-bottom: none;
  }
`;
